import { Component, Input } from '@angular/core';
import { IconNames } from '@shared/enums/icon-names';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-ice-info-icon',
  templateUrl: './ice-info-icon.component.html',
  styleUrls: ['./ice-info-icon.component.scss'],
  imports: [MatIcon, MatTooltip],
})
export class IceInfoIconComponent {
  @Input() tooltip: string;
  @Input() disabled: boolean = false;
  IconNames = IconNames;
}
